import React, { useEffect, useRef } from 'react';
import { Translate, useTranslate } from '../../../core/translate';
import PropTypes from 'prop-types';
import SvgIcon from '../../../core/icons/SvgIcon';
import Modal, {
  ModalBody,
  ModalHeader,
  onCloseModal,
} from '../../components/modal/Modal';

const LegalNotificationModal = ({ setExpiration = () => {}, onClose }) => {
  const [modalIsOpen, setIsOpen] = React.useState(true);
  const translate = useTranslate();
  const header = translate('instructions.symbols');

  const timeout = 500;
  const closeModal = () => {
    setIsOpen(false);
    setExpiration();
    onCloseModal(onClose, timeout);
  };

  const modalIsOpenRef = useRef(modalIsOpen);
  modalIsOpenRef.current = modalIsOpen;

  /* The timer below closes the modal after 15 seconds if the modal has not been closed by the user.
    I am following this pattern for the timer below: https://upmostly.com/tutorials/settimeout-in-react-components-using-hooks
     */

  useEffect(() => {
    const timer = setTimeout(() => {
      if (modalIsOpenRef.current) closeModal();
    }, 15000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Modal
      isOpen={true}
      fullscreen={false}
      className="legal-disclosure__modal"
      overlayClassName="legal-disclosure__modal-overlay"
      contentLabel={header}
      onRequestClose={onClose}>
      <ModalHeader
        text={header}
        onClose={closeModal}
        className="legal-disclosure__header"
        useLargeIcon={false}
      />
      <ModalBody innerClassName="legal-disclosure-content__inner">
        <div className="legal-disclosure-content__message-box-container">
          <SvgIcon
            name="alert"
            className="instructions__icon legal-alert__icon legal-disclosure-content__svg"
          />

          <div className="legal-disclosure-content__message-box">
            <p>
              <Translate value="instructions.feature.availability.text" />
            </p>
          </div>
        </div>
        <div className="legal-disclosure-content__message-box-container">
          <SvgIcon
            className="option-link__svg legal-disclosure-content__svg"
            name="info-toast"
          />
          <div className="legal-disclosure-content__message-box">
            <Translate value="instructions.more.info.text" />
          </div>
        </div>
        <div className="legal-disclosure-content__message-box-container">
          <SvgIcon
            className="option-link__svg legal-disclosure-content__svg"
            name="dagger"
          />
          <div className="legal-disclosure-content__message-box">
            <Translate value="instructions.disclosures.text" />
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

LegalNotificationModal.propTypes = {
  setExpiration: PropTypes.func,
};

export default LegalNotificationModal;
